<ion-app>
  <p-toast styleClass="app-toast" [baseZIndex]="20000"></p-toast>
  <ion-router-outlet></ion-router-outlet>
</ion-app>
